import React from 'react';
import { StyleSheet, View } from 'react-native';

import { BodyText, Button, LoadingAnimation, theme } from '@sg/garnish';

export const BagLoadingState = (props: BagLoadingStateProps) => {
  const { title, body, cta, isLoading, onPress } = props;

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <View style={styles.loading}>
          <LoadingAnimation testID="bag-loading-state" />
        </View>

        {title ? (
          <BodyText sizeMatch={['24']} style={styles.title}>
            {title}
          </BodyText>
        ) : null}

        {body ? (
          <BodyText sizeMatch={['16']} style={styles.body}>
            {body}
          </BodyText>
        ) : null}
      </View>

      {cta ? (
        <Button
          size="large-wide"
          palette="kaleLightest"
          style={styles.cta}
          accessibilityLabel={cta}
          isLoading={isLoading}
          onPress={onPress}
        >
          {cta}
        </Button>
      ) : null}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: theme.spacing['6'],
    paddingVertical: theme.spacing['10'],
    gap: theme.spacing['6'],
  },
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing['6'],
  },
  loading: {
    height: 200,
  },
  title: {
    textAlign: 'center',
    color: theme.colors.KALE,
  },
  body: {
    textAlign: 'center',
  },
  cta: {
    minHeight: 64,
    alignItems: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type BagLoadingStateProps = {
  title: string;
  body: string;
  cta: string | null;
  isLoading: boolean;
  onPress: () => void;
};
